<template>
  <div class="flex flex-col items-center justify-center gap-3 px-4 py-12 text-center">
    <div class="flex size-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
      <UIcon
        :name="icon"
        class="size-7"
      />
    </div>
    <div class="space-y-1">
      <p class="text-base font-semibold text-[var(--arad-text)]">
        {{ title }}
      </p>
      <p
        v-if="description"
        class="max-w-sm text-sm leading-relaxed text-[var(--ui-text-muted)]"
      >
        {{ description }}
      </p>
    </div>
    <div
      v-if="$slots.actions"
      class="mt-1 flex flex-wrap items-center justify-center gap-2"
    >
      <slot name="actions" />
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    icon?: string
    title: string
    description?: string
  }>(),
  {
    icon: 'i-lucide-inbox',
    description: undefined,
  },
)
</script>
